export class HpStripeBanner {
	root: HTMLElement;
	media: HTMLElement;

	constructor(root: HTMLElement) {
		this.root = root;
		this.root.dataset.height = '';

		this.media = root.querySelector<HTMLElement>('.banner-media img, .banner-media picture, .banner-media video')
			|| root.querySelector<HTMLElement>('.banner-media')
			|| root;

		const resizeObserver = new ResizeObserver(this.update);
		resizeObserver.observe(this.root);
		resizeObserver.observe(this.media);
		resizeObserver.observe(document.documentElement);
		this.update();
	}

	update = () => {
		if (!this.root.isConnected) return;

		this.root.dataset.height = `${this.media.offsetHeight}px`;
		this.root.style.setProperty('--banner-height', `${this.media.offsetHeight}px`);
	};
}

export const init = () => {
	const banners = Array.from(document.querySelectorAll<HTMLElement>('.hp-stripe-banner[data-auto-height]'));
	const instances: HpStripeBanner[] = [];

	for (const root of banners) {
		if (!('height' in root.dataset)) instances.push(new HpStripeBanner(root));
	}

	return instances;
};

export default {
	init
};
